import { render, staticRenderFns } from "./SupplyChainReportTab.vue?vue&type=template&id=15f858b8"
import script from "./SupplyChainReportTab.vue?vue&type=script&lang=js"
export * from "./SupplyChainReportTab.vue?vue&type=script&lang=js"
import style0 from "./SupplyChainReportTab.vue?vue&type=style&index=0&id=15f858b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports